import {useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import {Accordion, Icon, Popup} from 'semantic-ui-react'
import {RxStopwatch} from 'react-icons/rx'
import {IEvent, IUserLabelsMap} from '@/features/labeling'
import {EventButtons, IEventButtonsRef} from './event-buttons'
import './style.css'

export interface IPredictionsPanelProps {
  data?: {
    predictions?: IEvent[]
  }
  userLabels?: IUserLabelsMap
  userRows?: string[]
  channelTypeDescriptions?: {
    [key: string]: string
  }
  selectedEvent?: IEvent
  setSelectedEvent?: (e: IEvent) => void
}

export function PredictionsPanel(props: IPredictionsPanelProps) {
  const {data, userLabels, userRows, channelTypeDescriptions, selectedEvent, setSelectedEvent} =
    props

  const eventButtonsRef = useRef<{[key: string]: IEventButtonsRef}>({})

  const [activePanels, setActivePanels] = useState<string[]>()
  const [events, setEvents] = useState<{
    [type: string]: IEvent[]
  }>()
  const [knownEventTypes, setKnownEventTypes] = useState<string[]>()

  useEffect(() => {
    const _events = _.chain(data)
      .get('predictions')
      .groupBy((v) => v.type)
      .value()
    setEvents(_events)
  }, [data])

  useEffect(() => {
    setKnownEventTypes(
      _.chain(events)
        .keys()
        .concat(userRows || [])
        .value()
    )
  }, [events, userRows])

  useEffect(() => {
    if (!knownEventTypes) return
    if (activePanels) return
    setActivePanels(knownEventTypes)
  }, [knownEventTypes])

  useEffect(() => {
    if (!selectedEvent) return
    if (!selectedEvent.type) return
    if (!_.includes(activePanels, selectedEvent.type)) {
      setActivePanels((prev) => [...(prev || []), selectedEvent.type as string])
    }
    if (!eventButtonsRef.current) return
    const _ref = eventButtonsRef.current[selectedEvent.type]
    if (_ref) _ref.scrollTo(selectedEvent)
  }, [selectedEvent])

  function handleSetSelectedEvent(event: IEvent) {
    if (!setSelectedEvent) return
    setSelectedEvent(event)
  }

  function handleOnTitleClick(id: string) {
    setActivePanels((prev) => {
      if (!_.includes(prev, id)) return _.concat(prev || [], [id])
      return _.without(prev || [], id)
    })
  }

  return (
    <div className='predictions-panel'>
      {/* <div className='actions'></div> */}
      <div className='content'>
        <Accordion>
          {events ?
            _.chain(events)
              .toPairs()
              .concat(_.map(userRows, (t) => [t, []] as [string, IEvent[]]))
              .uniqBy(([k]) => k)
              .map(([k, v]) => {
                const description = _.get(channelTypeDescriptions, _.toLower(k))
                return [
                  <Accordion.Title
                    key={`title-${k}`}
                    active={_.includes(activePanels, k)}
                    onClick={() => handleOnTitleClick(k)}
                  >
                    <Icon name='dropdown' />
                    {description ?
                      <Popup
                        size='tiny'
                        trigger={<div>{k}</div>}
                        content={description}
                      />
                    : k}
                  </Accordion.Title>,
                  <Accordion.Content
                    key={`content-${k}`}
                    active={_.includes(activePanels, k)}
                  >
                    {v && v.length > 0 ?
                      <EventButtons
                        ref={(r) => {
                          if (!r) delete eventButtonsRef.current[k]
                          else eventButtonsRef.current[k] = r
                        }}
                        events={v}
                        userLabels={userLabels}
                        selectedEvent={selectedEvent}
                        setSelectedEvent={handleSetSelectedEvent}
                      />
                    : <div
                        style={{
                          display: 'flex',
                          justifyContent: 'end',
                        }}
                      >
                        <Popup
                          size='tiny'
                          content={'create selection'}
                          trigger={
                            <button
                              onClick={() =>
                                handleSetSelectedEvent({
                                  type: k,
                                  start: 0,
                                })
                              }
                              onFocus={(e) => e.target.blur()}
                              children={
                                <>
                                  <RxStopwatch />+
                                </>
                              }
                            />
                          }
                        />
                      </div>
                    }
                  </Accordion.Content>,
                ]
              })
              .value()
          : null}
        </Accordion>

        {/* <Grid celled centered>
                {events ? (
                    _.chain(events)
                    .toPairs()
                    .concat(_.map(userRows, t => [t, []] as [string, IEvent[]]))
                    .uniqBy(([k]) => k)
                    .map(([k, v]) => {
                        return <Grid.Row key={k}>
                            <Grid.Column width={3} textAlign='right'>
                                <div
                                    children={k}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => {
                                        if (!selectedEvent) return;
                                        handleSetSelectedEvent({
                                            type: k,
                                            start: selectedEvent.start,
                                            end: selectedEvent.end,
                                        });
                                    }}
                                />
                            </Grid.Column>
                            <Grid.Column width={13}>
                                <EventButtons
                                    events={v}
                                    denoise={denoise}
                                    denoiseThreshold={denoiseThreshold}
                                    userLabels={userLabels}
                                    setSelectedEvent={handleSetSelectedEvent}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    })
                    .value()
                ) : null}
            </Grid> */}
      </div>
    </div>
  )
}
